import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

const PlatformPageHeader = ({
  icon: Icon,
  eyebrow = 'VITRIA',
  title,
  subtitle,
  actions,
  sx,
}) => (
  <Box
    component="header"
    sx={{
      display: 'flex',
      alignItems: { xs: 'flex-start', md: 'flex-end' },
      justifyContent: 'space-between',
      flexDirection: { xs: 'column', md: 'row' },
      gap: 3,
      mb: { xs: 4.5, md: 6 },
      ...sx,
    }}
  >
    <Box sx={{ maxWidth: 760 }}>
      <Stack direction="row" alignItems="center" spacing={1.1} sx={{ mb: 1.5 }}>
        {Icon && (
          <Box
            sx={(theme) => ({
              display: 'grid',
              width: 30,
              height: 30,
              placeItems: 'center',
              border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
              borderRadius: '50%',
              color: 'primary.light',
              bgcolor: alpha(theme.palette.primary.main, 0.12),
              '& svg': { fontSize: 16 },
            })}
          >
            <Icon />
          </Box>
        )}
        <Typography variant="overline" sx={{ color: 'primary.light' }}>
          {eyebrow}
        </Typography>
      </Stack>
      <Typography variant="h2" component="h1" sx={{ mb: subtitle ? 1.75 : 0 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 650, fontSize: { md: '1.04rem' } }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {actions && <Box sx={{ flexShrink: 0 }}>{actions}</Box>}
  </Box>
);

export default PlatformPageHeader;
